import { Box, Button, Heading } from "@chakra-ui/react";
import { useAtom } from "jotai";
import type { PropsWithChildren } from "react";
import { type ReactElement, useEffect } from "react";
import { useLocation } from "react-router";
import { usePromiseToast } from "../hooks/use-promise-toast";
import { sessionAtom } from "../stores/session";
import { setDefaultProp } from "../utils/posthog";
import rpc from "../utils/rpc";

export const hashExemptPattern =
    /\/(login|shipments\/confirm|surveys\/preview)/;

export default function LoginGuard(p: PropsWithChildren): ReactElement {
    const [session, setSession] = useAtom(sessionAtom);
    const loc = useLocation();
    const { withToast } = usePromiseToast();

    useEffect(() => {
        if (loc.pathname.match(hashExemptPattern)) return;
        withToast(
            async () => {
                const self = await rpc.users.getSelf();
                setDefaultProp("uid", self.id);
                setSession(prev => ({
                    ...prev,
                    ...self,
                }));
            },
            {
                swallowError: true,
                messages: {
                    error: "Failed to fetch account details",
                },
            },
        );
    }, [loc.pathname]);

    if (session?.id || session?.token || loc.pathname.match(hashExemptPattern))
        return <>{p.children}</>;

    return (
        <Box height="100%" display="flex" alignItems="center">
            <Box textAlign="center" width="100%">
                <Heading size="lg">Access Denied!</Heading>
                {LOGIN_URL && (
                    <ul>
                        <li>
                            <Button
                                colorPalette="blue" // need toverify this style
                                my={4}
                            >
                                <a href={LOGIN_URL}>Login</a>
                            </Button>
                        </li>
                    </ul>
                )}
                <p>
                    Alternatively, please reach out to the
                    <a
                        href="mailto://tech@theruraltrust.com"
                        style={{
                            textDecoration: "underline",
                            marginLeft: "5px",
                            marginRight: "5px",
                        }}
                    >
                        tech team
                    </a>
                    for assistance!
                </p>
            </Box>
        </Box>
    );
}
